import { useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBuyerOverridesPartialPaymentAmount } from '../state/BuyerOverrides/selectors';
import BuyerOverridesActionTypes from '../state/BuyerOverrides/actionTypes';
import { useTransactionLimits } from './useTransactionLimits';
export function useInitializePartialPaymentAmount({
  checkoutSession,
  selectedPaymentMethod
}) {
  var _limits$maximumAmount2;
  const {
    limits,
    loading: limitsLoading
  } = useTransactionLimits();
  const dispatch = useDispatch();
  const partialPaymentAmount = useSelector(getBuyerOverridesPartialPaymentAmount);
  const previousPaymentMethodRef = useRef(null);
  const partialPaymentsInfo = checkoutSession.partialPaymentsInfo;
  const maxLimitForSelectedPaymentMethod = useMemo(() => {
    var _limits$maximumAmount;
    return limits === null || limits === void 0 || (_limits$maximumAmount = limits.maximumAmountForPaymentMethod) === null || _limits$maximumAmount === void 0 ? void 0 : _limits$maximumAmount[selectedPaymentMethod];
  }, [selectedPaymentMethod, limits === null || limits === void 0 ? void 0 : limits.maximumAmountForPaymentMethod]);
  const balanceDue = partialPaymentsInfo !== null && partialPaymentsInfo !== void 0 && partialPaymentsInfo.isPartialPaymentsEnabled ? partialPaymentsInfo === null || partialPaymentsInfo === void 0 ? void 0 : partialPaymentsInfo.balanceDue : undefined;
  const maxLimitForPreviouslySelectedPaymentMethod = previousPaymentMethodRef.current ? limits === null || limits === void 0 || (_limits$maximumAmount2 = limits.maximumAmountForPaymentMethod) === null || _limits$maximumAmount2 === void 0 ? void 0 : _limits$maximumAmount2[previousPaymentMethodRef.current] : undefined;
  useEffect(() => {
    if (limitsLoading || typeof balanceDue !== 'number') {
      return;
    }
    const paymentMethodChanged = previousPaymentMethodRef.current !== null && previousPaymentMethodRef.current !== selectedPaymentMethod;
    const paymentAmountEqualsPreviousPaymentMethodLimit = typeof maxLimitForPreviouslySelectedPaymentMethod === 'number' && typeof partialPaymentAmount === 'number' && partialPaymentAmount === maxLimitForPreviouslySelectedPaymentMethod;
    if (partialPaymentAmount === undefined) {
      const amountToSet = typeof maxLimitForSelectedPaymentMethod === 'number' ? Math.min(balanceDue, maxLimitForSelectedPaymentMethod) : balanceDue;
      dispatch({
        type: BuyerOverridesActionTypes.SET_PARTIAL_PAYMENT_AMOUNT,
        data: {
          partialPaymentAmount: amountToSet
        }
      });
    } else if (paymentMethodChanged && paymentAmountEqualsPreviousPaymentMethodLimit) {
      dispatch({
        type: BuyerOverridesActionTypes.SET_PARTIAL_PAYMENT_AMOUNT,
        data: {
          partialPaymentAmount: maxLimitForSelectedPaymentMethod
        }
      });
    }
    previousPaymentMethodRef.current = selectedPaymentMethod;
  }, [dispatch, partialPaymentAmount, limits === null || limits === void 0 ? void 0 : limits.maximumAmountForPaymentMethod, balanceDue, limitsLoading, maxLimitForSelectedPaymentMethod, selectedPaymentMethod, maxLimitForPreviouslySelectedPaymentMethod]);
}